import React from 'react';
import { apiRequest } from "../utils/api";
import '../styles/CashTransactionModal.css';
import { useAlert } from '../components/AlertModal';

const SalesDetailModal = ({
    showCashTransactionModal,
    closeCashTransactionModal,
    input,
    setInput,
    register,
}) => {
    const { showAlert } = useAlert();

    if (!showCashTransactionModal) return null;

    const handleOutsideClick = (event) => {
        if (event.target === event.currentTarget) {
            closeCashTransactionModal();
            setInput('');
        }
    };

    const purchasewithdrawal = async (transaction_Type) => {
        let Transaction_Type = "";

        if (transaction_Type === 1) {
            Transaction_Type = "deposit";
        } else if (transaction_Type === 2) {
            Transaction_Type = "withdrawal";
        } else if (transaction_Type === 3) {
            Transaction_Type = "expenses";
        } else if (transaction_Type === 4) {
            Transaction_Type = "purchase_payment";
        } else if (transaction_Type === 5) {
            Transaction_Type = "purchase";
        } else {
            showAlert("タイプ選択エラー管理者にお問い合わせ下さい");
            return;
        }

        const amountValue = Number(input);

        if (!amountValue || Number.isNaN(amountValue) || amountValue <= 0) {
            showAlert("金額を入力してください");
            return;
        }

        try {
            await apiRequest("inventory/register/cash-transaction/", "POST", {
                register_id: register,
                transaction_type: Transaction_Type,
                amount: amountValue,
                date: new Date().toISOString(),
            });

            closeCashTransactionModal();
            setInput('');
            showAlert("登録しました");
        } catch (error) {
            console.error("支払いの処理中にエラーが発生しました:", error);
            showAlert("支払い処理に失敗しました。もう一度お試しください。");
        }
    };

    return (
        <div className='cashTransactionlModal' onClick={handleOutsideClick}>
            <div className='cashmodalContent'>
                <span className="close" onClick={closeCashTransactionModal}>
                    &times;
                </span>
                <h2>買取処理・出入金</h2>
                <div className='cashTransactionlnumber'>￥{input}</div>
                <div className='Purchasewithdrawalbox'>
                    <button
                        className='Purchasewithdrawal'
                        onClick={() => purchasewithdrawal(4)}
                    >
                        買取支払
                    </button>
                </div>
                <div className='cashTransactionlbox'>
                    <button onClick={() => purchasewithdrawal(3)}>経費</button>
                    <button onClick={() => purchasewithdrawal(5)}>仕入れ</button>
                    <button onClick={() => purchasewithdrawal(2)}>現金移動(出金)</button>
                    <button
                        className='cashTransactionldeposit'
                        onClick={() => purchasewithdrawal(1)}
                    >
                        現金移動(入金)
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SalesDetailModal;